import { ReactElement, useCallback } from 'react';
import { SiteListCard } from '@components/lms/siteListWrapper/components/siteListCard/siteListCard';
import { useInfiniteScroll } from '@components/common';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { useSiteListRxDb } from '@services/hooks/lms/siteList/useSiteListRxDb';
import { NoDataFound } from '@components/common/no-data-found/noDataFound';
import { useSetMainHeader } from '@hooks/useSetMainHeader';
import { useSiteListQuery } from '@services/hooks/lms/siteList/useSiteListQuery';
import { useRefetchList } from '@helper/fetchData';
import { useCompetitionFilterStore } from '@store/lms/competitionFilterStore';

export const CompetitionSiteList = (): ReactElement => {
	useSetMainHeader('Site Summary');
	useRefetchList(['AllSites']);
	const { isFetching: queryFetch, error } = useSiteListQuery();
	const { competitionFilter } = useCompetitionFilterStore();
	const { fetchMore, isFetching, result } = useSiteListRxDb(competitionFilter);

	const handleFetchMore = useCallback(() => {
		fetchMore();
	}, [fetchMore]);

	useInfiniteScroll(handleFetchMore);

	return (
		<Wrapper isLoaderVisible={queryFetch || (isFetching && result.length === 0)} isError={error}>
			<div className="common-list-card site-list-card">
				<ul className="row">
					{result.length > 0 ? (
						result.map((site) => <SiteListCard key={site._data.id} site={site._data} isContractorSite={false} />)
					) : (
						<NoDataFound message="No Data Found!" />
					)}
				</ul>
			</div>
		</Wrapper>
	);
};
